<template>
  <div class="row">
    <div class="col-md-12">
      <p class="clearfix"></p>
      <referral-campaign-form :route="route"></referral-campaign-form>
    </div>
  </div>
</template>

<script>
import ReferralCampaignForm from './ReferralCampaignForm.vue'

export default {
  components: { ReferralCampaignForm },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Referral/ReferralCampaignEdit.vue